/**
 * Design tokens — Florida State University garnet & gold.
 *
 * Brand values are FSU's published brand colors (brand.fsu.edu/visual-style):
 * FSU Garnet #782F40, FSU Gold #CEB888, Stadium Night #101820, Plaza Brick
 * #572932, Gulf Sands #DFD1A7, Legacy Blue #425563 (accent). FSU's rules:
 * garnet is never lightened, gold is never darkened, primaries dominate.
 *
 * Accessibility (WCAG contrast, checked): garnet on white 9.2:1, ink on page
 * background 16.4:1, muted on white 6.8:1, gold on garnet 4.75:1. Gold on
 * white is only 1.9:1, so gold is used for fills, rules and accents — never
 * as text on a light background.
 *
 * Evidence-status colors (supportGreen / warnAmber / dangerRed) stay distinct
 * hues on purpose: they carry meaning, and must not be confused with the
 * garnet brand color. Keep apps/extension/src/content/presentation.ts in sync.
 */
export const colors = {
    background: "#f7f5ef",
    surface: "#ffffff",
    border: "#e2dccb",
    ink: "#101820",
    muted: "#555c63",
    brand: "#782f40",
    brandHover: "#572932",
    gold: "#ceb888",
    goldSoft: "#dfd1a7",
    goldTint: "#f3eee2",
    accentBlue: "#425563",
    accentBlueBg: "#e9ecef",
    supportGreen: "#2e6b4b",
    supportGreenBg: "#eaf2ec",
    warnAmber: "#8a6414",
    dangerRed: "#a03a2c",
    dangerRedBg: "#f6e8e5",
    neutralChipBg: "#f3eee2",
};
export const fonts = {
    serif: "'Source Serif 4', Georgia, serif",
    sans: "'Source Sans 3', system-ui, sans-serif",
};
export const radii = {
    sm: "6px",
    md: "10px",
    lg: "16px",
    pill: "999px",
};
export const spacing = (n) => `${n * 4}px`;
